const auth0ProxyUrl = window.location.hostname === 'localhost' ?
  'http://localhost:8080/api/v1/authManagementProxy' : '/api/v1/authManagementProxy';

const postPutHeaders = {
  'X-Requested-With': 'XMLHttpRequest',
  'Content-type': 'application/json',
};
const getHeaders = {
  'X-Requested-With': 'XMLHttpRequest',
};

// only used in commented out code
export const createAuthRole = async (role, token) => {
  const headers = {
    ...postPutHeaders,
    'Authorization': `Bearer ${token}`,
  };

  const response = await fetch(`${auth0ProxyUrl}/roles`, {
    body: JSON.stringify(role),
    method: 'POST',
    headers: headers,
  });

  if (!response.ok) {
    const { status, statusText } = response;

    throw new Error(`Creating Auth0 role unsuccessful: ${statusText}, status ${status}`);
  }

  const createdRoles = await response.json();

  return createdRoles;
};

export const getAuthRoles = async (token) => {
  const headers = {
    ...getHeaders,
    'Authorization': `Bearer ${token}`,
  };

  const response = await fetch(`${auth0ProxyUrl}/roles`,
    {
      headers: headers,
    },
  );

  if (!response.ok) {
    const { status, statusText } = response;

    throw new Error(`Getting Auth0 roles unsuccessful: ${statusText}, status ${status}`);
  }

  const authRoles = await response.json();

  return authRoles;
};

// only used in commented out code
export const setAuthPermissionsToAPI = async (id, permissions, token) => {
  const serverId = encodeURIComponent(id);
  const headers = {
    ...postPutHeaders,
    'Authorization': `Bearer ${token}`,
  };

  const response = await fetch(`${auth0ProxyUrl}/resource-servers/${serverId}`,
    {
      body: JSON.stringify(permissions),
      method: 'PATCH',
      headers: headers,
    },
  );

  if (!response.ok) {
    const { status, statusText } = response;

    throw new Error(`Patching Auth0 permissions unsuccessful: ${statusText}, status ${status}`);
  }

  const updateResourceServer = await response.json();

  return updateResourceServer;
};

// only used in commented out code
export const setAuthPermissionToRole = async (roleId, permissions, token) => {
  const headers = {
    ...postPutHeaders,
    'Authorization': `Bearer ${token}`,
  };

  const response = await fetch(`${auth0ProxyUrl}/roles/${roleId}/permissions`, {
    body: JSON.stringify(permissions),
    method: 'POST',
    headers: headers,
  });

  if (!response.ok) {
    const { status, statusText } = response;

    throw new Error(`Creating Auth0 role(s) unsuccessful: ${statusText}, status ${status}`);
  }

  return;
};
